export default "__VITE_ASSET__BHocZzds__"